import { useTranslation } from "react-i18next";

/** Shows only recorded evidence, never derives consent from submission or signature dates. */
export function PrivacyConsentEvidence({ consent }: { consent: unknown }): JSX.Element {
  const { t } = useTranslation();
  const value =
    consent && typeof consent === "object" ? (consent as Record<string, unknown>) : null;
  const recorded = value?.accepted === true;
  const receivedAt = typeof value?.received_at === "string" ? value.received_at : null;
  const statement =
    value?.statement && typeof value.statement === "object"
      ? (value.statement as Record<string, unknown>)
      : null;
  return (
    <section className="space-y-2 rounded-lg border border-slate-200 p-4">
      <h2 className="text-sm font-semibold">{t("privacy_evidence.title")}</h2>
      <p>{t(recorded ? "privacy_evidence.recorded" : "privacy_evidence.absent")}</p>
      <p className="text-sm text-slate-600">{t("privacy_evidence.limit")}</p>
      {recorded && (
        <>
          <p>
            {t("privacy_evidence.received")}:{" "}
            {receivedAt ? (
              <time dateTime={receivedAt}>{receivedAt}</time>
            ) : (
              t("privacy_evidence.not_recorded")
            )}
          </p>
          <p>
            {t("privacy_evidence.text")}:{" "}
            {typeof statement?.text === "string"
              ? statement.text
              : t("privacy_evidence.not_recorded")}
          </p>
        </>
      )}
    </section>
  );
}
